import {
  Check,
  ChevronDown,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Typography,
} from '@v2/ui';
import { cn } from '@v2/utils';

type SortOption = {
  name: string;
  value: string;
};

interface SortByDropdownProps {
  options: SortOption[];
  value: string;
  onSelect: (value: string) => void;
  children?: React.ReactNode;
  className?: string;
  triggerClassName?: string;
  asChild?: boolean;
}

export function SortByDropdown({
  options,
  value,
  onSelect,
  children,
  className,
  triggerClassName,
  asChild,
}: SortByDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        asChild={asChild}
        className={cn(
          'focus:outline-2 focus:outline-offset-2 focus:outline-gray-800',
          triggerClassName
        )}
      >
        {children || (
          <Typography
            size="tmd"
            className="inline-flex items-center gap-x-1.5 font-semibold"
          >
            Sort by{' '}
            {options.find((opt) => opt.value === value)?.name || 'Default'}
            <ChevronDown />
          </Typography>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={cn('min-w-[250px]', className)}
        align="start"
      >
        {options.map((item) => (
          <DropdownMenuItem
            textValue={item.value}
            key={item.value}
            className="justify-between"
            onSelect={() => onSelect(item.value)}
          >
            {item.name}
            {item.value === value && (
              <Check
                className="text-gray-800"
                pathProps={{
                  stroke: 'currentColor',
                }}
              />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
